module.exports = __webpack_public_path__ + "static/media/monica.34143781.jpg";